import type { LiveDiagram } from "@scoach/types";
import { Modal } from "@scoach/ui";
import { Expand } from "@scoach/ui/icons";

import { MermaidDiagram } from "./diagrams/MermaidDiagram.tsx";
import { openDiagramInNewTab } from "./diagrams/openDiagramInNewTab.ts";

/**
 * Full-window popup for a single architecture diagram. Renders the Mermaid chart
 * large (with its own zoom toolbar) inside a wide Modal so the user can inspect it.
 */
export function DiagramLightbox({
  diagram,
  onClose,
}: {
  diagram: LiveDiagram | null;
  onClose: () => void;
}) {
  return (
    <Modal
      open={!!diagram}
      onClose={onClose}
      title={diagram ? `#${diagram.index} · ${diagram.title}` : undefined}
      width="min(1100px, 92vw)"
    >
      {diagram && (
        <>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
            <button
              type="button"
              className="ghost-btn"
              title="Open full presentation slide in a new tab to share live on Google Meet / Zoom / Teams"
              onClick={() => void openDiagramInNewTab(diagram.title, diagram.mermaid)}
            >
              <Expand size={13} style={{ marginRight: 4 }} /> 🖥️ Present / Share Slide
            </button>
          </div>
          <div style={{ maxHeight: "80vh", overflow: "auto" }}>
            <MermaidDiagram chart={diagram.mermaid} zoomable />
          </div>
        </>
      )}
    </Modal>
  );
}
